import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la/'
import { laChannelCount, laDiscountPriceMonthly } from 'src/constants/planData/latinoPlanData'
import { useIsLatinoBundleAvailable } from 'src/modules/hooks/useIsLatinoBundleAvailable'

export default (props) => {
  const latinoBundlePlan = useIsLatinoBundleAvailable({ lang: 'es' })
  const isLatinoBundleAvailable = latinoBundlePlan !== null

  let title = (
    <>
      Ahorra en TV <span className="no-wrap">en vivo para</span>{' '}
      <span className="no-wrap">toda la familia</span>
    </>
  )
  let subtitle = (
    <>
      Más de {laChannelCount} canales con deportes, noticias y{' '}
      <span className="desktop-line-break">
        entretenimiento en español desde solo{' '}
        <span className="green-underline">${laDiscountPriceMonthly}</span> el primer mes.
      </span>
    </>
  )
  let pageDescription = `Transmite canales de FOX Deportes, ESPN Deportes, beIN SPORTS y más con Fubo.`

  if (latinoBundlePlan?.rsnName) {
    title = 'Mira a tus equipos locales'
    let channel = latinoBundlePlan?.rsnName ?? 'FanDuel Sports Network'
    subtitle = `Accede a ${channel} y más de ${laChannelCount} canales de TV en vivo y deportes en español`
    pageDescription = `Transmite canales de ${channel}, FOX Deportes, ESPN Deportes, beIN SPORTS y más con Fubo.`
  }

  return (
    <LatinoTemplateDefault
      location={props.location}
      lang="es"
      market="latino"
      poster="https://assets-imgx.fubo.tv/marketing/lp/images/posters/rsn_basketbal_hockey-web.jpg"
      posterMobile="https://assets-imgx.fubo.tv/marketing/lp/images/posters/rsn_basketbal_hockey-mobile.jpg"
      title={title}
      subtitle={subtitle}
      networkSet="entertainmentLatino"
      customNetworks={['espndeportes']}
      noteLink="/la/latino-plus-beisbol/"
      pageDescription={pageDescription}
      disableLAPlanCards={isLatinoBundleAvailable}
      forceAnchorLink={isLatinoBundleAvailable}
      hasPlanCards={isLatinoBundleAvailable}
      plans={[latinoBundlePlan]}
    />
  )
}
